/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Download_TitleInputs */

const en_gc_resources_download_title = /** @type {(inputs: Gc_Resources_Download_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download GridCraft. Make it yours.`)
};

const zh_gc_resources_download_title = /** @type {(inputs: Gc_Resources_Download_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载 GridCraft，自由开始。`)
};

/**
* | output |
* | --- |
* | "Download GridCraft. Make it yours." |
*
* @param {Gc_Resources_Download_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_download_title = /** @type {((inputs?: Gc_Resources_Download_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Download_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_download_title(inputs)
	return zh_gc_resources_download_title(inputs)
});
export { gc_resources_download_title as "gc.resources.download.title" }